
export default {
  computed: {
    phone() {
      return this.$slots.default[0].text
    },
  },
}
